import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const user = await login(email, password); // get user info from login
      if (user.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/dashboard"); // normal user dashboard
      }
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 mt-5 pb-2">
            Admin Login
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 fs-5 mb-4">
            Sign in to manage loan applications
          </p>
        </div>

        {error && (
          <div className="bg-red-100 text-red-700 p-4 rounded mb-4">
            {error}
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center">
          <form
            className="w-100"
            style={{ maxWidth: "550px" }}
            onSubmit={handleSubmit}
          >
            <div className="mb-3">
              <label htmlFor="email" className="form-label fs-5">
                Email address
              </label>
              <input
                type="email"
                className="form-control py-3"
                id="email"
                name="email"
                placeholder="Email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="mb-3 position-relative">
              <label htmlFor="password" className="form-label fs-5">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control py-3"
                id="password"
                name="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary position-absolute top-50 mt-3 end-0 translate-middle-y me-2"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1} // avoid tab stop on this button
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  // Eye-off icon (Bootstrap icon example)
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-slash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.359 11.238l1.387 1.387-1.06 1.06-1.387-1.387A7.213 7.213 0 018 13c-3.21 0-5.978-2.063-7-5a8.04 8.04 0 012.053-3.254L2.06 4.414 3.12 3.354l10.24 10.24-1.06 1.06z" />
                    <path d="M11.257 9.93a3 3 0 01-4.18-4.18l4.18 4.18z" />
                    <path d="M5.384 5.384a3 3 0 014.18 4.18l-4.18-4.18z" />
                  </svg>
                ) : (
                  // Eye icon
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8z" />
                    <path d="M8 11a3 3 0 100-6 3 3 0 000 6z" />
                  </svg>
                )}
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-100 py-3 mt-3 fs-5"
            >
              {loading ? "Logging in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
